export const baseUrl = 'https://us-east1-future-geolocation-technology.cloudfunctions.net'
export const googleMapsKey = 'AIzaSyDLzmA19VRAUrCUYoB0v7sRo1LM1o-5sNY'
